import DiscourseRoute from 'discourse/routes/discourse';
import { ajax } from 'discourse/lib/ajax';

export default class ProxyviewsCalculatorRoute extends DiscourseRoute {
  titleToken() {
    return 'Proxy Cost Calculator';
  }

  model() {
    return ajax('/calculator/data.json');
  }
}
